import { useState } from 'react';

export default function FormConsulenza() {
  const [formData, setFormData] = useState({
    // Dati personali
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    ruolo: '',
    
    // Dati azienda
    nomeAzienda: '',
    partitaIva: '',
    settore: '',
    dimensioneAzienda: '',
    sitoWeb: '',
    
    // Dati brand
    nomeBrand: '',
    anniFondazione: '',
    mercatiPresenza: '',
    fatturato: '',
    
    // Richiesta
    tipoServizio: '',
    motivazione: '',
    urgenza: '',
    note: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    // Validazione email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    // Validazione campi obbligatori
    if (!formData.nome || !formData.cognome || !formData.email || !formData.telefono || 
        !formData.nomeAzienda || !formData.nomeBrand || !formData.tipoServizio) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5ld4p2deasqilubg560', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          cognome: '',
          email: '',
          telefono: '',
          ruolo: '',
          nomeAzienda: '',
          partitaIva: '',
          settore: '',
          dimensioneAzienda: '',
          sitoWeb: '',
          nomeBrand: '',
          anniFondazione: '',
          mercatiPresenza: '',
          fatturato: '',
          tipoServizio: '',
          motivazione: '',
          urgenza: '',
          note: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contatti-form" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Richiedi la Tua Consulenza
          </h2>
          <p className="text-lg sm:text-xl text-slate-600">
            Compila il form per ricevere una pre-analisi gratuita del valore del tuo brand
          </p>
        </div>

        <form 
          id="form-consulenza"
          data-readdy-form
          onSubmit={handleSubmit} 
          className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 space-y-8"
        >
          {/* Dati Personali */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6 pb-3 border-b-2 border-[#22C55E]">
              Dati Personali
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-semibold text-slate-700 mb-2">
                  Nome <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Mario"
                />
              </div>
              <div>
                <label htmlFor="cognome" className="block text-sm font-semibold text-slate-700 mb-2">
                  Cognome <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="cognome"
                  name="cognome"
                  value={formData.cognome}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Rossi"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="mario.rossi@azienda.it"
                />
              </div>
              <div>
                <label htmlFor="telefono" className="block text-sm font-semibold text-slate-700 mb-2">
                  Telefono <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="+39 333 1234567"
                />
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="ruolo" className="block text-sm font-semibold text-slate-700 mb-2">
                  Ruolo in Azienda
                </label>
                <input
                  type="text"
                  id="ruolo"
                  name="ruolo"
                  value={formData.ruolo}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Es: CEO, Direttore Marketing, Commercialista..."
                />
              </div>
            </div>
          </div>

          {/* Dati Azienda */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6 pb-3 border-b-2 border-[#22C55E]">
              Dati Azienda
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="sm:col-span-2">
                <label htmlFor="nomeAzienda" className="block text-sm font-semibold text-slate-700 mb-2">
                  Nome Azienda <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="nomeAzienda"
                  name="nomeAzienda"
                  value={formData.nomeAzienda}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Nome della tua azienda"
                />
              </div>
              <div>
                <label htmlFor="partitaIva" className="block text-sm font-semibold text-slate-700 mb-2">
                  Partita IVA
                </label>
                <input
                  type="text"
                  id="partitaIva"
                  name="partitaIva"
                  value={formData.partitaIva}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="IT12345678901"
                />
              </div>
              <div>
                <label htmlFor="settore" className="block text-sm font-semibold text-slate-700 mb-2">
                  Settore
                </label>
                <input
                  type="text"
                  id="settore"
                  name="settore"
                  value={formData.settore}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Es: Moda, Food, Tech..."
                />
              </div>
              <div>
                <label htmlFor="dimensioneAzienda" className="block text-sm font-semibold text-slate-700 mb-2">
                  Dimensione Azienda
                </label>
                <select
                  id="dimensioneAzienda"
                  name="dimensioneAzienda"
                  value={formData.dimensioneAzienda}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                >
                  <option value="">Seleziona...</option>
                  <option value="1-10">1-10 dipendenti</option>
                  <option value="11-50">11-50 dipendenti</option>
                  <option value="51-250">51-250 dipendenti</option>
                  <option value="250+">Oltre 250 dipendenti</option>
                </select>
              </div>
              <div>
                <label htmlFor="sitoWeb" className="block text-sm font-semibold text-slate-700 mb-2">
                  Sito Web
                </label>
                <input
                  type="url"
                  id="sitoWeb"
                  name="sitoWeb"
                  value={formData.sitoWeb}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="https://www.azienda.it"
                />
              </div>
            </div>
          </div>

          {/* Dati Brand */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6 pb-3 border-b-2 border-[#22C55E]">
              Dati Brand
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="sm:col-span-2">
                <label htmlFor="nomeBrand" className="block text-sm font-semibold text-slate-700 mb-2">
                  Nome Brand <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="nomeBrand"
                  name="nomeBrand"
                  value={formData.nomeBrand}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Nome del brand da valutare"
                />
              </div>
              <div>
                <label htmlFor="anniFondazione" className="block text-sm font-semibold text-slate-700 mb-2">
                  Anno di Fondazione
                </label>
                <input
                  type="text"
                  id="anniFondazione"
                  name="anniFondazione"
                  value={formData.anniFondazione}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Es: 2010"
                />
              </div>
              <div>
                <label htmlFor="mercatiPresenza" className="block text-sm font-semibold text-slate-700 mb-2">
                  Mercati di Presenza
                </label>
                <input
                  type="text"
                  id="mercatiPresenza"
                  name="mercatiPresenza"
                  value={formData.mercatiPresenza}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                  placeholder="Es: Italia, Europa, Mondiale"
                />
              </div>
              <div className="sm:col-span-2">
                <label htmlFor="fatturato" className="block text-sm font-semibold text-slate-700 mb-2">
                  Fascia di Fatturato Annuo
                </label>
                <select
                  id="fatturato"
                  name="fatturato"
                  value={formData.fatturato}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                >
                  <option value="">Seleziona...</option>
                  <option value="0-500k">0 - 500.000 €</option>
                  <option value="500k-2M">500.000 € - 2 milioni €</option>
                  <option value="2M-10M">2 - 10 milioni €</option>
                  <option value="10M-50M">10 - 50 milioni €</option>
                  <option value="50M+">Oltre 50 milioni €</option>
                </select>
              </div>
            </div>
          </div>

          {/* Richiesta Consulenza */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6 pb-3 border-b-2 border-[#22C55E]">
              Dettagli Richiesta
            </h3>
            <div className="space-y-6">
              <div>
                <label htmlFor="tipoServizio" className="block text-sm font-semibold text-slate-700 mb-2">
                  Tipo di Servizio <span className="text-red-500">*</span>
                </label>
                <select
                  id="tipoServizio"
                  name="tipoServizio"
                  value={formData.tipoServizio}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                >
                  <option value="">Seleziona il servizio...</option>
                  <option value="pre-analisi">Pre-Analisi Gratuita</option>
                  <option value="perizia">Perizia Certificata BCI</option>
                  <option value="brand-capital">Sistema Brand Capital</option>
                  <option value="governance">Governance Brand</option>
                  <option value="altro">Altro</option>
                </select>
              </div>
              <div>
                <label htmlFor="motivazione" className="block text-sm font-semibold text-slate-700 mb-2">
                  Motivazione della Richiesta
                </label>
                <select
                  id="motivazione"
                  name="motivazione"
                  value={formData.motivazione}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                >
                  <option value="">Seleziona...</option>
                  <option value="bilancio">Iscrizione a Bilancio</option>
                  <option value="investimento">Ricerca Investitori</option>
                  <option value="cessione">Cessione/Acquisizione</option>
                  <option value="garanzia">Garanzia Bancaria</option>
                  <option value="contenzioso">Contenzioso Legale</option>
                  <option value="strategia">Strategia Aziendale</option>
                  <option value="altro">Altro</option>
                </select>
              </div>
              <div>
                <label htmlFor="urgenza" className="block text-sm font-semibold text-slate-700 mb-2">
                  Tempistiche
                </label>
                <select
                  id="urgenza"
                  name="urgenza"
                  value={formData.urgenza}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all text-sm"
                >
                  <option value="">Seleziona...</option>
                  <option value="urgente">Urgente (entro 1 settimana)</option>
                  <option value="breve">Breve termine (1-4 settimane)</option>
                  <option value="medio">Medio termine (1-3 mesi)</option>
                  <option value="lungo">Lungo termine (oltre 3 mesi)</option>
                </select>
              </div>
              <div>
                <label htmlFor="note" className="block text-sm font-semibold text-slate-700 mb-2">
                  Note Aggiuntive
                </label>
                <textarea
                  id="note"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-[#22C55E] focus:ring-2 focus:ring-[#22C55E]/20 outline-none transition-all resize-none text-sm"
                  placeholder="Raccontaci di più sul tuo brand e sulle tue esigenze... (max 500 caratteri)"
                />
                <p className="text-xs text-slate-500 mt-1">
                  {formData.note.length}/500 caratteri
                </p>
              </div>
            </div>
          </div>

          {/* Privacy */}
          <div className="bg-slate-50 rounded-lg p-6">
            <p className="text-sm text-slate-600 leading-relaxed">
              Inviando questo form accetti il trattamento dei tuoi dati personali secondo la nostra Privacy Policy. 
              I tuoi dati saranno utilizzati esclusivamente per rispondere alla tua richiesta di consulenza.
            </p>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full sm:w-auto inline-flex items-center justify-center px-10 py-4 bg-[#22C55E] text-white font-bold text-lg rounded-lg hover:bg-[#16A34A] transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none whitespace-nowrap"
            >
              {isSubmitting ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Invio in corso...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-fill mr-2"></i>
                  Invia Richiesta
                </>
              )}
            </button>
          </div>

          {/* Status Messages */}
          {submitStatus === 'success' && (
            <div className="bg-green-50 border-2 border-green-500 rounded-lg p-6 text-center">
              <i className="ri-checkbox-circle-fill text-4xl text-green-500 mb-3"></i>
              <h4 className="text-xl font-bold text-green-900 mb-2">Richiesta Inviata con Successo!</h4>
              <p className="text-green-700">
                Grazie per averci contattato. Riceverai una risposta entro 24 ore.
              </p>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="bg-red-50 border-2 border-red-500 rounded-lg p-6 text-center">
              <i className="ri-error-warning-fill text-4xl text-red-500 mb-3"></i>
              <h4 className="text-xl font-bold text-red-900 mb-2">Errore nell'invio</h4>
              <p className="text-red-700">
                Si è verificato un errore. Verifica che tutti i campi obbligatori siano compilati correttamente.
              </p>
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
